"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Outline = void 0;
var ArrowLeft_1 = require("./ArrowLeft");
var ArrowRight_1 = require("./ArrowRight");
var Audio_1 = require("./Audio");
var Calendar_1 = require("./Calendar");
var ChevronLeft_1 = require("./ChevronLeft");
var ChevronRight_1 = require("./ChevronRight");
var Exit_1 = require("./Exit");
var Gallery_1 = require("./Gallery");
var Lock_1 = require("./Lock");
var Mail_1 = require("./Mail");
var Task_1 = require("./Task");
var Time_1 = require("./Time");
var Video_1 = require("./Video");
var User_1 = require("./User");
var Plus_1 = require("./Plus");
var Paying_1 = require("./Paying");
var NonPaying_1 = require("./NonPaying");
var Trial_1 = require("./Trial");
var Info_1 = require("./Info");
var Copy_1 = require("./Copy");
exports.Outline = {
    ArrowLeft: ArrowLeft_1.ArrowLeft,
    ArrowRight: ArrowRight_1.ArrowRight,
    Audio: Audio_1.Audio,
    Calendar: Calendar_1.Calendar,
    ChevronLeft: ChevronLeft_1.ChevronLeft,
    ChevronRight: ChevronRight_1.ChevronRight,
    Exit: Exit_1.Exit,
    Gallery: Gallery_1.Gallery,
    Lock: Lock_1.Lock,
    Mail: Mail_1.Mail,
    Task: Task_1.Task,
    Time: Time_1.Time,
    Video: Video_1.Video,
    User: User_1.User,
    Plus: Plus_1.Plus,
    Paying: Paying_1.Paying,
    NonPaying: NonPaying_1.NonPaying,
    Trial: Trial_1.Trial,
    Info: Info_1.Info,
    Copy: Copy_1.Copy,
};
